import React, { Component } from 'react';
import AbEnvironment from '../auth/AbEnvironment';
import withStyles from '@mui/styles/withStyles';
import { Grid, Paper, Typography } from '@mui/material';
import { NumericFormat } from 'react-number-format';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
    paper: {
        marginTop: 16,
        paddingTop: 16,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        // color: theme.palette.text.secondary,
    },
    dbTile: {
      /*
      [theme.breakpoints.up('xs')]: {
        padding: theme.spacing(1),
      },
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(1),
      },
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(2),
      },
      */
      padding: theme.spacing(1),
      height: 68,
      width: 227
    },
    dbTile2: {
      padding: theme.spacing(1),
      height: 68,
      width: 160
    }
});

class VendorDashboardSummary extends Component {

    state = {
      show: false,
      pendingCount: null,
      resellerCount: null,
      activeResellerCount: null,
      subscriptionCount: null,
      totalBilled: null,
      billed90Days: null
    };

    componentDidMount() {

      const { callPartnerApi, logError } = this.props.auth;
      let accountId = abEnvironment.getUserAttribute('a_id');

  
      let aPjwt = abEnvironment.getPjwt();
  
      let payload = {
        operation: "getVendorDashboardSubscriptionCharges",
        params: {
          pJwt: aPjwt,
          accountId: accountId,
          registered: this.props.registered
        }
      };
  
      callPartnerApi('appbind/generic',
                     'POST',
                     payload
      )
      .then(resp => {
        return resp.json();
      })
      .then(response => {
        if (response != null) {
          let jsonResponse = JSON.parse(response);
          let data = jsonResponse.data.getvendordashboardsubscriptioncharges;
          this.setState({ show: true,
            pendingCount: data.pendingCount,
            resellerCount: data.resellerCount,
            activeResellerCount: data.activeResellerCount,
            subscriptionCount: data.subscriptionCount,
            totalBilled: data.ttlTmBcSum,
            billed90Days: data.ttlThrmBcSum
          });
          return;
        }

      })
      .catch(error => {
        logError('Exception in VendorDashboardSummary.js: ' + error);
      });
    }

    render() {
        const classes = this.props.classes;
  
        if (this.state.show) {

            return ( 
                <Paper className={classes.paper}>
                  {/* Title segment */}
                  {this.props.registered === 0 &&
                    <React.Fragment>
                      <Typography variant="h6">Anonymous resellers</Typography>
                      <Typography variant="body2">
                        Summary of subscriptions resold by potential partners
                      </Typography>
                    </React.Fragment>
                  }
                  {this.props.registered === 1 &&
                    <React.Fragment>
                      <Typography variant="h6">Registered partners</Typography>
                      <Typography variant="body2">
                        Summary of subscriptions resold by registered resale partners
                      </Typography>
                    </React.Fragment>
                  }

                  {/* Cards with data about resellers */}
                  {this.props.registered === 0 &&
                  <Grid container spacing={3} justifyContent="flex-start" style={{marginTop: 8}}>
                    <Grid item>
                      <Grid container spacing={3}>
                        {/* Resellers */}
                        <Grid item>
                          <Paper className={classes.dbTile}>
                            <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                              <Grid item>
                                <Typography variant="h6">
                                  <NumericFormat
                                    value={this.state.resellerCount}
                                    valueIsNumericString
                                    displayType="text"
                                    decimalScale={0}
                                    fixedDecimalScale
                                    thousandSeparator/>
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Typography variant="body2" style={{marginTop: 2}}>
                                  Resellers
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>

                        {/* Subscription count */}
                        <Grid item>
                          <Paper className={classes.dbTile}>
                            <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                              <Grid item>
                                <Typography variant="h6">
                                  <NumericFormat
                                    value={this.state.subscriptionCount}
                                    valueIsNumericString
                                    displayType="text"
                                    decimalScale={0}
                                    fixedDecimalScale
                                    thousandSeparator/>
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Typography variant="body2" style={{marginTop: 2}}>
                                  Subscriptions
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>

                        {/* 90days billed */}
                        <Grid item>
                          <Paper className={classes.dbTile}>
                            <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                              <Grid item>
                                <Typography variant="h6">
                                  <NumericFormat
                                    value={this.state.billed90Days ? this.state.billed90Days : 0}
                                    valueIsNumericString
                                    prefix={'$'} 
                                    displayType="text"
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator/>
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Typography variant="body2" style={{marginTop: 2}}>
                                  Billed last 90 days
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>

                        {/* Total billed */}
                        <Grid item>
                          <Paper className={classes.dbTile}>
                            <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                              <Grid item>
                                <Typography variant="h6">
                                  <NumericFormat
                                    value={this.state.totalBilled ? this.state.totalBilled : 0}
                                    valueIsNumericString
                                    prefix={'$'} 
                                    displayType="text"
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator/>
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Typography variant="body2" style={{marginTop: 2}}>
                                  Total billed
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>}

                  {this.props.registered === 1 &&
                  <Grid container spacing={3} justifyContent="flex-start" style={{marginTop: 8}}>
                    <Grid item>
                      <Grid container spacing={3}>
                        {/* Pending resellers (applied to commission/partner program) -- don't show if no programs? */}
                        <Grid item>
                          <Paper className={classes.dbTile2}>
                            <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                              <Grid item>
                                <Typography variant="h6">
                                  <NumericFormat
                                    value={this.state.pendingCount}
                                    valueIsNumericString
                                    displayType="text"
                                    decimalScale={0}
                                    fixedDecimalScale
                                    thousandSeparator/>
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Typography variant="body2" style={{marginTop: 2}}>
                                  Pending partners
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>

                        {/* Registered resellers (partners) */}
                        <Grid item>
                          <Paper className={classes.dbTile2}>
                            <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                              <Grid item>
                                <Typography variant="h6">
                                  <NumericFormat
                                    value={this.state.resellerCount}
                                    valueIsNumericString
                                    displayType="text"
                                    decimalScale={0}
                                    fixedDecimalScale
                                    thousandSeparator/>
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Typography variant="body2" style={{marginTop: 2}}>
                                  Registered partners
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>

                        {/* Activated resellers */}
                        <Grid item>
                          <Paper className={classes.dbTile2}>
                            <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                              <Grid item>
                                <Typography variant="h6">
                                  <NumericFormat
                                    value={this.state.activeResellerCount}
                                    valueIsNumericString
                                    displayType="text"
                                    decimalScale={0}
                                    fixedDecimalScale
                                    thousandSeparator/>
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Typography variant="body2" style={{marginTop: 2}}>
                                  Activated partners
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>

                        {/* Subscriptions provisioned */}
                        <Grid item>
                          <Paper className={classes.dbTile2}>
                            <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                              <Grid item>
                                <Typography variant="h6">
                                  <NumericFormat
                                    value={this.state.subscriptionCount}
                                    valueIsNumericString
                                    displayType="text"
                                    decimalScale={0}
                                    fixedDecimalScale
                                    thousandSeparator/>
                                </Typography>
                              </Grid>
                              <Grid item>
                                  <Typography variant="body2" style={{marginTop: 2}}>
                                    Subscriptions
                                  </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>

                        {/* Total billed last 90 days */}
                        <Grid item>
                          <Paper className={classes.dbTile2}>
                            <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                              <Grid item>
                                <Typography variant="h6">
                                  <NumericFormat
                                    value={this.state.billed90Days ? this.state.billed90Days : 0}
                                    valueIsNumericString
                                    prefix={'$'} 
                                    displayType="text"
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator/>
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Typography variant="body2" style={{marginTop: 2}}>
                                  Billed last 90 days
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>

                        {/* Total billed */}
                        <Grid item>
                          <Paper className={classes.dbTile2}>
                            <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
                              <Grid item>
                                <Typography variant="h6">
                                  <NumericFormat
                                    value={this.state.totalBilled ? this.state.totalBilled : 0}
                                    valueIsNumericString
                                    prefix={'$'} 
                                    displayType="text"
                                    decimalScale={2}
                                    fixedDecimalScale
                                    thousandSeparator/>
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Typography variant="body2" style={{marginTop: 2}}>
                                  Total billed
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>}

                </Paper>
                );
              } else {
                return (
                  <Paper>
                  </Paper>
                );
              }

     }
}

export default withStyles(styleSheet)(VendorDashboardSummary);